import React from 'react';
import { Text, Spinner, SpinnerSize, Stack, StackDirection } from '@televet/kibble-ui';

interface ILoadingSpinner {
  message?: string;
  size?: SpinnerSize;
  direction?: StackDirection;
}

const LoadingSpinner = ({ message, size = 'md', direction = 'column' }: ILoadingSpinner): JSX.Element => {
  return (
    <Stack direction={direction} align="center" spacing={4}>
      <Spinner size={size} />
      {message && <Text>{message}</Text>}
    </Stack>
  );
};

export default LoadingSpinner;
